import { FooterLink, FooterStyled, FooterText } from './Footer.styled';
import { PRIVACY_POLICY, TERMS_AND_CONDITIONS } from 'routes/routes';
import logo from '../../assets/images/travelutionLogo.png';
import { Div } from '../../styles/Styles';
import { colors } from 'styles/GlobalStyles';

const siteURL = process.env.REACT_APP_URL;

export const Footer = () => {
  return (
    <FooterStyled>
      <Div $flex $center $mb='24'>
        <img src={logo} alt='travelution' />
      </Div>
      <Div
        $flex
        $between
        $alignCenter
        $columnSM
        $gap='30px'
        $gapSM='12px'
        $reverseSM
      >
        <FooterText>© 2025 TRAVELUTION</FooterText>
        <Div $flex $alignCenter $gap='30px' $gapSM='12px' $columnSM>
          <a
            href={`/terms_of_service_travelution.pdf`}
            target='_blank'
            rel='noreferrer'
            style={{ color: colors.white }}
          >
            <span>Terms & Conditions</span>
          </a>{' '}
          <a
            href={`/privacy_policy_travelution.pdf`}
            target='_blank'
            rel='noreferrer'
            style={{ color: colors.white }}
          >
            <span>Privacy policy</span>
          </a>{' '}
        </Div>
      </Div>
    </FooterStyled>
  );
};
